import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../core/modules/Actions";

export const useQuestionEdit = () => {
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState({});
  const [showEditWarning, setShowEditWarning] = useState(false);
  const [editQuestion, setEditQuestion] = useState(false);
  const [editingQuestionId, setEditingQuestionId] = useState(null);

  const questionAssociation = useSelector((state) =>
    state.questions.get("questionAssociation")
  );

  const associateQuizzes = Array.isArray(questionAssociation?.associate_quizzes)
    ? questionAssociation.associate_quizzes
    : [];

  const handleEditQuestion = async (item, currentQuizName = "") => {
    const questionId = item?.id ?? item?.question_id;
    setEditingQuestionId(questionId);
    try {
      const response = await dispatch(Actions.questions.checkQuestionAssociation(questionId));
      const payload = response?.data || response?.payload?.data || response;
      const quizzesList = payload?.associate_quizzes;
      
      const normalizedCurrentQuizName = (currentQuizName || "").trim().toLowerCase();
      
      let isAssociated = false;
      if (Array.isArray(quizzesList)) {
        if (normalizedCurrentQuizName) {
          isAssociated = !(quizzesList.length === 1 && (quizzesList[0] || "").trim().toLowerCase() === normalizedCurrentQuizName) && quizzesList.length > 0;
        } else {
          isAssociated = quizzesList.length > 0;
        }
      }

      setSelectedItem({
        ...item,
        id: questionId,
      });
      if (isAssociated) {
        setShowEditWarning(true);
      } else {
        setEditQuestion(true);
      }
    } catch (error) {
      console.error("Error checking question association:", error);
      setSelectedItem({
        ...item,
        id: questionId,
      });
      setEditQuestion(true);
    } finally {
      setEditingQuestionId(null);
    }
  };

  const onConfirmEdit = () => {
    setShowEditWarning(false);
    setEditQuestion(true);
  };

  const onCancelEdit = () => {
    setShowEditWarning(false);
    setSelectedItem({});
  };

  const onEditQuestionClose = (onCloseCallback) => {
    setEditQuestion(false);
    setSelectedItem({});
    if (typeof onCloseCallback === "function") {
      onCloseCallback();
    }
  };

  const checkQuestionAssociation = async (questionId) => {
    return await dispatch(Actions.questions.checkQuestionAssociation(questionId));
  };

  return {
    selectedItem,
    setSelectedItem,
    showEditWarning,
    setShowEditWarning,
    editQuestion,
    setEditQuestion,
    editingQuestionId,
    associateQuizzes,
    handleEditQuestion,
    onConfirmEdit,
    onCancelEdit,
    onEditQuestionClose,
    checkQuestionAssociation,
  };
};
